import { render } from "./DatePickerComponent.vue?vue&type=template&id=84d76fe4&ts=true"
import script from "./DatePickerComponent?vue&type=script&lang=ts"
export * from "./DatePickerComponent?vue&type=script&lang=ts"

import "./_assets/_DatePicker.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/runner/work/xebel/xebel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__